import { NgModule, Pipe } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TranslateModule } from '@ngx-translate/core'; // Import the TranslateModule
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        AdminRoutingModule,
        TranslateModule,
        SharedModule,
        AdminComponent, DashboardComponent
    ],
    exports: [
        AdminComponent, DashboardComponent
    ],
})
export class AdminModule { }
